import { useTheme, alpha as hexAlpha } from '@mui/material/styles';

import { fShortenNumber } from 'src/utils/format/format-number';

import { Chart, useChart } from 'src/components/chart';

// ----------------------------------------------------------------------

export type ChartLineProps = {
  chart: any;
};

export function ChartLine({ chart }: ChartLineProps) {
  const theme = useTheme();

  const chartColors = chart.colors ?? [
    hexAlpha(theme.palette.primary.dark, 0.8),
    theme.palette.warning.main,
  ];

  const formatYAxisLabel = (value: any) =>
    fShortenNumber(Number(value) || 0, { maximumFractionDigits: 1 }).replace(/[km]/g, (match) => match.toUpperCase());

  const chartYAxis = Array.isArray(chart.yaxis)
    ? chart.yaxis.map((axis: any = {}) => ({
      ...axis,
      labels: {
        ...(axis.labels ?? {}),
        formatter: formatYAxisLabel,
      },
    }))
    : {
      ...(chart.yaxis ?? {}),
      labels: {
        ...((chart.yaxis && chart.yaxis.labels) ?? {}),
        formatter: formatYAxisLabel,
      },
    };

  const chartOptions = useChart({
    colors: chartColors,
    legend: { show: true },
    xaxis: { categories: chart.categories },
    yaxis: chartYAxis,
    markers: {
      size: 4,
      strokeWidth: 2,
    },
  });

  return <Chart type="line" series={chart.series} options={chartOptions} sx={{ height: 320 }} />;
}
